import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { SmoothScroll } from "@/components/SmoothScroll";
import { GrainOverlay } from "@/components/GrainOverlay";
import { CinematicCursor } from "@/components/CinematicCursor";
import { Navigation } from "@/components/Navigation";

import { Hero } from "@/components/sections/Hero";
import { About } from "@/components/sections/About";
import { Team } from "@/components/sections/Team";
import { Projects } from "@/components/sections/Projects";
import { Capabilities } from "@/components/sections/Capabilities";
import { Contact } from "@/components/sections/Contact";
import { Footer } from "@/components/sections/Footer";

const Home = () => {
    return (
        <>
            <Navigation />
            <main>
                <Hero />
                <About />
                <Team />
                <Projects />
                <Capabilities />
                <Contact />
            </main>
            <Footer />
        </>
    );
};

function App() {
    useEffect(() => {
        document.documentElement.classList.add("dark");
        document.title = "Studio Shakthi — Full Services Movie Production Co.";
    }, []);

    return (
        <div className="App">
            <SmoothScroll />
            <GrainOverlay />
            <CinematicCursor />
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "hsl(240 6% 9%)",
                        color: "hsl(0 0% 96%)",
                        border: "1px solid hsla(0,0%,100%,0.10)",
                    },
                }}
            />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
